import {
  ClientFormValues,
  ValidationFormErrors,
  ValidationFormsModeEnum,
} from "./types";

export function validateClient(
  values: ClientFormValues,
  mode: ValidationFormsModeEnum,
  original?: ClientFormValues
): ValidationFormErrors {
  const errors: ValidationFormErrors = {};

  if (!values.firstName || values.firstName.trim() === "") {
    errors.firstName = "Введіть ім’я.";
  }

  if (!values.lastName || values.lastName.trim() === "") {
    errors.lastName = "Введіть прізвище.";
  }

  if (!values.phone || !/^\+?\d{12}$/.test(values.phone)) {
    errors.phone = "Введіть коректний номер телефону.";
  }

  if (!values.responsibleContact || values.responsibleContact.trim() === "") {
    errors.responsibleContact = "Вкажіть відповідального контакта.";
  }

  if (!values.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    errors.email = "Введіть коректний email.";
  }

  if (!values.type || values.type === "") {
    errors.stage = "Вкажіть тип клієнта.";
  }

  if (mode === "edit" && original) {

  }

  return errors;
}
